// Copyright (c) 2018 Deere & Company

import * as busyCounter from './busy-counter';
import actions from '../actions-list';
import {deleteExcelLayout as deleteExcelLayoutObject} from '../repositories';
import {readExcelLayouts} from './read-excel-layouts';
import {successAlertBar} from '../../shared/services/alert-bar';
import {translate} from '../services/translation-service';
import {updateExcelLayoutModalVisibility} from './excel-layout-modal';

export const deleteExcelLayout = (name, listId, feature) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteExcelLayoutObject(name, listId);

            updateExcelLayoutModalVisibility(false)(dispatch);

            /* reset the state so we never see any part of that layout again */

            dispatch({
                type: actions.RESET_EXPORT_TO_EXCEL_LAYOUT
            });

            dispatch({
                listId,
                type: actions.RESET_EXPORT_TO_EXCEL_SELECTED_LAYOUT
            });

            successAlertBar(translate('LAYOUT_DELETED_SUCCESSFULLY'));

            readExcelLayouts(feature)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/delete-excel-layout.js